const STORAGE_KEY = 'kk-theme';

const systemPrefersDark = () => window.matchMedia('(prefers-color-scheme: dark)').matches;

const systemTheme = () => (systemPrefersDark() ? 'dark' : 'light');

const currentTheme = () => {
    const explicit = document.documentElement.getAttribute('data-theme');

    if (explicit === 'dark' || explicit === 'light') {
        return explicit;
    }

    return systemTheme();
};

const store = (theme) => {
    try {
        localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {
        return false;
    }

    return true;
};

const clearStored = () => {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
        return false;
    }

    return true;
};

const FADE_CLASS = 'is-theme-fade';
const FADE_MS = 450;

export default function ThemeToggle() {
    const buttons = Array.from(document.querySelectorAll('[data-theme-toggle]'));

    if (!buttons.length) {
        return;
    }

    let fadeTimer = null;

    const fade = () => {
        document.documentElement.classList.add(FADE_CLASS);

        window.clearTimeout(fadeTimer);
        fadeTimer = window.setTimeout(() => {
            document.documentElement.classList.remove(FADE_CLASS);
        }, FADE_MS);
    };

    const syncLabels = () => {
        const isDark = currentTheme() === 'dark';

        buttons.forEach((button) => {
            button.setAttribute('aria-pressed', String(isDark));
            button.setAttribute(
                'aria-label',
                isDark ? button.dataset.labelToLight : button.dataset.labelToDark,
            );
        });
    };

    const apply = (theme) => {
        if (theme === systemTheme()) {
            document.documentElement.removeAttribute('data-theme');
            clearStored();
        } else {
            document.documentElement.setAttribute('data-theme', theme);
            store(theme);
        }

        syncLabels();
    };

    buttons.forEach((button) => {
        button.addEventListener('click', () => {
            const next = currentTheme() === 'dark' ? 'light' : 'dark';
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            if (!reduceMotion) {
                fade();
            }

            apply(next);
        });
    });

    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const onSystemChange = () => {
        const explicit = document.documentElement.getAttribute('data-theme');

        if (explicit === systemTheme()) {
            document.documentElement.removeAttribute('data-theme');
            clearStored();
        }

        syncLabels();
    };

    if (typeof media.addEventListener === 'function') {
        media.addEventListener('change', onSystemChange);
    } else {
        media.addListener(onSystemChange);
    }

    if (document.documentElement.getAttribute('data-theme') === systemTheme()) {
        document.documentElement.removeAttribute('data-theme');
        clearStored();
    }

    syncLabels();
}
